export enum UnifiedLabRecordType {
  UNSPECIFIED = 'Unspecified',
  LEGACY_LAB = 'Legacy lab',
  PREVIOUS_PROVIDER = 'Previous provider',
}
